<app-common-page-title *ngIf="detectDeviceService.isDesktop()" icon="assets/playbison/icons/icon-menu-promotions.svg"> <ng-container i18n>Switch ON Bison</ng-container> </app-common-page-title>
<div *ngIf="!reactivationData else reactive">
    <app-inner-loader></app-inner-loader>
</div>
<ng-template #reactive>
    <div class="reactivation-header" *ngIf="!detectDeviceService.isDesktop()">
        <app-mobile-page-back-header iconUrl="assets/playbison/icons/icon-menu-promotions.svg">Switch ON Bison</app-mobile-page-back-header>
    </div>
    <div class="reactivation-card-list" [ngClass]="(detectDeviceService.isDesktop()) ? 'desktop': 'mobile'">
        <div *ngFor="let item of reactivationData | keyvalue | slice:0:7; let index = index" class="reactivation-card" [class.active-scrollTop-card]="index === reactivationData?.currentRecursivePointer - 1" #reactivationcardElement>
            <app-reactivation-info *ngIf="item" [item]="item" [index]="index" [currentRecursivePointer]="reactivationData?.currentRecursivePointer"></app-reactivation-info>
        </div>
    </div>
</ng-template>